import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import { ITrackingFillMarketingConsentParameters } from '../shared/fillMarketingConsent';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackProductClickApply = (
  parameters: Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillMarketingConsentParameters &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { leadId } = parameters;

  return track({
    event: 'product_click_apply',
    action: 'click',
    item_list_name: 'ph_new_lead_capture_page',
    ...fillItems(parameters),
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
    component_type: 'bottom-sticky',
    component_title: 'CTA_Apply Now',
  });
};
